import { Link } from 'react-router-dom';
import { quickLinks } from '@/mocks/navigation';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-heart-3-fill text-primary-400 text-xl"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">
                爱情岛导航
              </span>
            </div>
            <p className="text-background-400 text-sm leading-relaxed">
              专注收录爱情岛论坛网址的最新官方入口，提供稳定可访问的地址导航与使用指南。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-background-50 font-semibold mb-4 text-sm">
              快速导航
            </h4>
            <ul className="space-y-2">
              {quickLinks.slice(0, 3).map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-background-400 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-background-50 font-semibold mb-4 text-sm">
              更多链接
            </h4>
            <ul className="space-y-2">
              {quickLinks.slice(3).map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-background-400 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/about"
                  className="text-background-400 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-background-50 font-semibold mb-4 text-sm">
              联系方式
            </h4>
            <ul className="space-y-2 text-background-400 text-sm">
              <li className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-xs"></i>
                </div>
                <span>support@aiqingdao.com</span>
              </li>
              <li className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-wechat-line text-xs"></i>
                </div>
                <span>aiqingdao_helper</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-500 text-xs">
            &copy; {new Date().getFullYear()} 爱情岛论坛网址导航 - 官方入口导航与最新地址
          </p>
          <p className="text-background-500 text-xs">
            本站仅提供地址导航服务，不存储任何论坛内容
          </p>
        </div>
      </div>
    </footer>
  );
}